import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { CircularProgress } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export default function Contact() {
    const { t } = useTranslation()

    const [loading, setLoading] = useState(false)
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [country, setCountry] = useState('')
    const [question, setQuestion] = useState('')
    const [inquired, setInquired] = useState(false)

    useEffect(() => {
        document.body.className = '';
        document.body.classList.add('contact');
    }, [])


    async function sendEmails(e) {
        if (!name || !phone || !email || !country) {
            return;
        }
        e.preventDefault()
        setLoading(true)
        try {
            await fetch('https://igtmail.netlify.app/.netlify/functions/igtmail', {
                method: 'POST',
                body: JSON.stringify({
                    // to: 'admin@devozilla.com',
                    to: 'moussa@intgroupuae.com',
                    subject: 'New Partner Inquiry',
                    text: `A new partner inquiry has been submitted on the website.
                        Data:
                        name: ${name}
                        phone: ${phone}
                        email: ${email}
                        country: ${country}
                        questions: ${question}
                    `,
                    html: `<h1>A new partner inquiry has been submitted on the website.</h1>
                        <h2>Data:</h2>
                        <ul>
                            <li>name: ${name}</li> 
                            <li>phone: ${phone}</li>
                            <li>email: ${email}</li>
                            <li>country: ${country}</li>
                            <li>questions: ${question}</li>
                        </ul>`
                }),
            });
            setName('')
            setPhone('')
            setEmail('')
            setCountry('')
            setQuestion('')
            setInquired(true)
        } catch (error) {
            console.error("Error sending emails:", error);
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            {loading && <div className='bkdrop' style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 99999999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}><CircularProgress sx={{ color: '#fff' }} /></div>}
            {inquired && <div onClick={() => setInquired(false)} className='bkdrop' style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 99999999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <div style={{
                    padding: '20px',
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    boxShadow: '0px 0px 10px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '20px',
                    maxWidth: '450px'
                }}>
                    <CheckCircleOutlineIcon sx={{
                        width: '100px',
                        height: '100px',
                        color: 'green'
                    }} />
                    <h2 style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        fontFamily: 'Playfair, sans-serif'
                    }}>{t('inquiry_sent')}</h2>
                </div>
            </div>}
            <div>
                <section className="nc min-h-[calc(100vh-150px)] mb-[70px] flex flex-col gap-[30px] justify-center items-center nc px-[20px] lg:px-[50px] py-[50px] lg:py-[5px]">
                    <div className="flex flex-col lg:flex-row w-full justify-center">
                        <div className="w-full lg:w-2/5 flex flex-col justify-center items-start gap-[10px]">
                            <h2 className="text-xl lg:text-6xl 2xl:text-7xl mb-[50px] is-slideup">{t('we_collaborate')}</h2>
                            <h2 className="max-w-1/2 text-lg lg:text-2xl 2xl:text-3xl font-black">{t('get_in_touch')}</h2>
                            <h2 className="max-w-1/2 text-lg lg:text-2xl 2xl:text-3xl font-black">{t('prompt_response')}</h2>
                            <div className="flex gap-[10px] items-center">
                                <h2 className="text-lg lg:text-xl 2xl:text-2xl w-[140px]">{t('reach_whatsapp')}</h2>
                                <a
                                    href="https://wa.me/+97165699999" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center w-12 h-12 lg:w-14 lg:h-14 rounded-full hover:text-[#d0a847] border border-[#d0a645] hover:bg-[#d0a645] transition-all duration-300 shadow-md" aria-label="X (Whatsapp)" >
                                    <FontAwesomeIcon icon={faWhatsapp} className="text-3xl lg:text-3xl text-[#0b0] group-hover:text-[#fff] transition-all duration-300" />
                                </a>
                                <h3 className="text-[#aaa] text-2xl font-thin capitalizeimp" style={{ fontFamily: 'Arial', textTransform: 'capitalize' }}>{t('whatsappp')}</h3>
                            </div>
                        </div>
                        <div className="w-[100px] h-[100px]"></div>
                        <div className="w-full lg:w-1/3 max-w-[500px] border-[.5px] border-[#D0A645] rounded-[20px] p-[20px] flex flex-col justify-center items-center">
                            <h1 className="text-3xl lg:text-4xl 2xl:text-6xl text-center w-full mb-[20px]">{t('contact')}</h1>
                            <div className="flex flex-col w-full gap-[20px] text-2xl">
                                <input value={name} onChange={(e)=>setName(e.target.value)} type="text" placeholder={t('name')} className="outline-none p-[10px] border-b-[2px] border-b-[#201b57] w-full" />
                                <input value={email} onChange={(e)=>setEmail(e.target.value)} type="text" placeholder={t('email')} className="outline-none p-[10px] border-b-[2px] border-b-[#201b57] w-full" />
                                <input value={phone} onChange={(e)=>setPhone(e.target.value)} type="text" placeholder={t('phone')} className="outline-none p-[10px] border-b-[2px] border-b-[#201b57] w-full" />
                                <input value={country} onChange={(e)=>setCountry(e.target.value)} type="text" placeholder={t('country')} className="outline-none p-[10px] border-b-[2px] border-b-[#201b57] w-full" />
                                <input value={question} onChange={(e)=>setQuestion(e.target.value)} type="text" placeholder={t('questions')} className="outline-none p-[10px] border-b-[2px] border-b-[#201b57] w-full" />
                            </div>
                            <div className="flex justify-end w-2/3 mt-[50px]">
                                <Link onClick={(e)=>sendEmails(e)} to='' className="text-white underline underline-offset-[5px] nbg p-[5px] rounded-full px-[20px] text-lg hover:bg-[#D0A847] hover:text-[#201B57] transition-all duration-[.3s]">{t('submit')}</Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="nc min-h-[calc(100vh-150px)] mb-[70px] flex flex-col gap-[30px] justify-center items-center nc px-[20px] lg:px-[100px] py-[50px] lg:py-[5px]">
                    <div className="flex flex-col lg:flex-row gap-[30px]">
                        <h2 className="w-full lg:w-1/3 p-[20px] text-xl lg:text-2xl 2xl:text-2xl border-[.5px] border-[#D0A645] rounded-[20px]">
                            <span className="flex flex-col min-w-[300px] lg:min-w-[500px] xl:min-w-[600px]">
                                <span>{t('head_office')}</span>
                                <span>{t('office_address1')}</span>
                                <span>{t('office_address2')}</span>
                                <span>{t('po_box')}</span>
                            </span>
                        </h2>
                        <h2 className="w-full lg:w-1/3 p-[20px] text-xl lg:text-2xl 2xl:text-2xl border-[.5px] border-[#D0A645] rounded-[20px]">
                            <span className="w-full h-full flex items-center" style={{ fontFamily: 'Time New Roman' }}>{t('tel')}</span>
                        </h2>
                        <h2 className="w-full lg:w-1/3 p-[20px] text-xl lg:text-2xl 2xl:text-2xl border-[.5px] border-[#D0A645] rounded-[20px] lowercase">
                            <span className="w-full h-full flex items-center"><span className="capitalize">{t('email')}</span>: {t('email_contact')}</span>
                        </h2>
                    </div>

                    <div className="w-full relative">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.7928869086977!2d55.45026527581364!3d25.277551728440468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5f834bf49b77%3A0xf59141cd2ba5ffda!2sInternational%20Group%20Trading%20Co%20LLC!5e0!3m2!1sen!2sae!4v1747960097930!5m2!1sen!2sae" className="w-full min-h-[380px]" style={{ border: 'none' }} allowfullscreen="" loading="lazy" title="International Group Trading Co. L.L.C" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </section>
            </div>
        </React.Fragment>
    )
}